// components/InfoSelectBox.jsx

import { ChevronRight } from "lucide-react";
import clsx from "clsx";

//MOBILE
interface Props {
  label: string;
  icon: any;
  value: string;
  placeholder?: string;
  onClick?: () => void;
  disabled?: boolean;
  truncate?: boolean;
  viewOnly?: boolean;
}

const InfoSelectBox = ({
  label,
  icon,
  value,
  placeholder,
  onClick,
  disabled = false,
  truncate = false,
  viewOnly = false,
}: Props) => {
  return (
    <div>
      <span className="block text-base font-medium text-gray-700 mb-2">
        {label}
      </span>
      <div
        className={clsx(
          "bg-white rounded-lg border border-gray-200 md:p-4 p-3 flex items-center justify-between",
          disabled && "bg-gray-100 cursor-not-allowed pointer-events-none",
          viewOnly ? "cursor-default" : "cursor-pointer"
        )}
        onClick={!disabled ? onClick : undefined}
      >
        <div
          className={clsx("flex items-center space-x-3", truncate && "w-full")}
        >
          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
            {icon}
          </div>
          <span
            className={clsx(
              "md:text-lg text-base font-normal",
              disabled ? "text-gray-400" : value ? "text-gray-900" : "text-gray-400",
              truncate && "truncate block max-w-full"
            )}
          >
            {value || placeholder}
          </span>
        </div>
        {!viewOnly && <ChevronRight className="w-5 h-5 text-gray-400" />}
      </div>
    </div>
  );
};

export default InfoSelectBox;
